// extracted by mini-css-extract-plugin
module.exports = {"root":"ApprovalAwatingModal_root__2xEpU","label":"ApprovalAwatingModal_label__3sJlC","paper":"ApprovalAwatingModal_paper__1a6Ok"};